import { trackGaEvent } from '@propertypal/shared/src/services/analytics';
import { NextRouter } from 'next/router';
import { useEffect, useState } from 'react';

interface UseCloseToSearchProps {
  page: string;
  router: NextRouter;
  loggedIn: boolean;
}

export const CLOSE_TO_QUERY_PARAM = 'closeTo';

const useCloseToSearch = ({ page, router, loggedIn }: UseCloseToSearchProps) => {
  const [closeToModal, setCloseToModal] = useState<boolean>(false);

  const { query } = router;

  const handleCloseToClick = (cta?: boolean) => {
    trackGaEvent('close_to_click', {
      page,
      location: cta ? 'CTA' : 'Search Box',
      position: cta ? undefined : 'suggestion',
    });

    if (loggedIn) {
      setCloseToModal(true);

      router.push(
        {
          pathname: router.pathname,
          query: { ...query, [CLOSE_TO_QUERY_PARAM]: 'true' },
        },
        undefined,
        { shallow: true },
      );
    } else {
      router.push({
        pathname: '/login',
        query: {
          sourcePath: `${router.asPath}${router.asPath?.includes('?') ? '&' : '?'}${CLOSE_TO_QUERY_PARAM}=true`,
        },
      });
    }
  };

  const onCloseCloseToModal = () => {
    setCloseToModal(false);

    const { [CLOSE_TO_QUERY_PARAM]: _, ...restQuery } = query;

    router.push(
      {
        pathname: router.pathname,
        query: restQuery,
      },
      undefined,
      { shallow: true },
    );
  };

  // Check for closeTo query string on initial load
  useEffect(() => {
    setCloseToModal(loggedIn && query?.[CLOSE_TO_QUERY_PARAM] === 'true');
  }, [query, loggedIn]);

  return { closeToModal, handleCloseToClick, onCloseCloseToModal };
};

export default useCloseToSearch;
